export function resolveGroupAvatarProfileTarget({
  message,
  artistLookup,
  assigneeLookup,
  buildArtistProfile,
  buildAdminProfile,
}) {
  if (!message) return null;

  const senderType = String(message?.sender_type || '').trim().toLowerCase();
  if (senderType === 'artist') {
    const artistId = String(message?.artist_user_id || message?.artist_id || '').trim();
    const source =
      artistLookup?.get?.(artistId) || {
        artist_id: message?.artist_user_id || message?.artist_id || null,
        artist_name: message?.artist_name || '',
        artist_name_en: message?.artist_name_en || '',
        artist_profile_picture: message?.artist_profile_picture || '',
        profile_one_liner: message?.artist_profile_one_liner || '',
        instagram_url: message?.artist_instagram_url || '',
        twitter_url: message?.artist_twitter_url || '',
        facebook_url: message?.artist_facebook_url || '',
        hp_url: message?.artist_hp_url || '',
        career_timeline: Array.isArray(message?.artist_career_timeline)
          ? message.artist_career_timeline
          : [],
      };
    const hasArtistIdentity = Boolean(
      source?.artist_id || source?.id || source?.artist_name || source?.name || source?.artist_name_en,
    );
    if (!hasArtistIdentity) return null;
    const profile = typeof buildArtistProfile === 'function' ? buildArtistProfile(source) : null;
    return profile ? { type: 'artist', profile } : null;
  }

  const adminId = String(message?.admin_user_id || message?.admin_id || '').trim();
  const source =
    assigneeLookup?.get?.(adminId) || {
      id: message?.admin_user_id || message?.admin_id || null,
      full_name: message?.admin_full_name || '',
      admin_full_name: message?.admin_full_name || '',
      username: message?.admin_username || '',
      nickname: message?.admin_nickname || '',
      position: message?.admin_position || '',
      department: message?.admin_department || '',
      profile_picture: message?.admin_profile_picture || '',
      admin_profile_picture: message?.admin_profile_picture || '',
      profile_one_liner: message?.admin_profile_one_liner || '',
      instagram_url: message?.admin_instagram_url || '',
      twitter_url: message?.admin_twitter_url || '',
      facebook_url: message?.admin_facebook_url || '',
      hp_url: message?.admin_hp_url || '',
    };
  const hasAdminIdentity = Boolean(
    source?.id || source?.admin_user_id || source?.full_name || source?.username || source?.nickname,
  );
  if (!hasAdminIdentity) return null;
  const profile = typeof buildAdminProfile === 'function' ? buildAdminProfile(source) : null;
  return profile ? { type: 'admin', profile } : null;
}
